import apiUrl from '../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import {
	Validator
} from 'vee-validate'
import DatePicker from 'vue2-datepicker'
import CryptoJS from 'crypto-js';
import moment from 'moment'
import {
	BasicSelect
} from 'vue-search-select'
import VueElementLoading from 'vue-element-loading';
import Multiselect from 'vue-multiselect'

export default {
	name: 'stocktransfer',
	components: {
		Paginate,
		DatePicker,
		BasicSelect,
		VueElementLoading,
		Multiselect
	},
	data: function() {
		return {
			shipmentRouteMode: '',
			clientArray: [],
			clientObjData: {
				id: "",
				text: "",
				accountid: "",
				detailiD: ""
			},
			shipmentRouteModeRuleObjData: {
				id: "",
				text: ""
			},
			shipmentRouteModeRuleArray: [],
			RuleDetails: [],
			ClientDetails: [],
			clientLoading: '',
			isLoading: false,
			addmodalshow: false,
			modalShow: false,
			modaldata: '',
			ShowShipmentRuleList: false,
			RuleModalShow: false,
			len: 0,
			COD: '',
			prepaid: '',
			RuleID: '',
			Client: '',
			ShipmentRouteModeRule: '',
			ShipmentRuleDetails: [],
			userData:[],
			isDisabled:false
		}
	},
	created: function() {},
	computed: {},
	filters: {
		moment: function(date) {
			if (date == null || date == '')
				return '--'
			return moment(date).format('DD-MM-YYYY');
		}
	},
	mounted() {
		var userdetailEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext)
		this.userData = userdetail;
		this.warehouseid = userdetail[0].warehouseid;
		this.createdBy = userdetail[0].email;
		this.loadClient()
		this.getRuleList()
	},
	methods: {
		loadClient() {
			this.clientArray = []
			this.input = ({
				BusinessFlow: "Forward",
				BusinessService: "Delivery"
			})
			this.clientLoading = 'Loading Client...'
			axios({
				method: "POST",
				'url': apiUrl.api_url_hubops + 'clientbusiness/account/names/flowservice',
				'data': this.input,
				headers: {
					'authorization': 'authkey xB84JJ89Hd25',
				}
			}).then(result => {
				this.clientLoading = ''
				var response = result.data;
				if (response.ResultCode == 100 && response.ResponseData.length > 0) {
					for (var i = 0; i < response.ResponseData.length; i++) {
						this.clientArray.push({
							id: response.ResponseData[i].ClientMasterID,
							text: response.ResponseData[i].AccountName + '(' + response.ResponseData[i].ClientMasterID + ')',
							accountid: response.ResponseData[i].ClientBusinessAccountId,
							detailiD: response.ResponseData[i].ClientBusinessDetailID
						})
					}
				}
			}, error => {
				console.error(error);
			});
		},
		selectedClient(clientObjData) {
			this.clientObjData = clientObjData
			this.Client = this.clientObjData.text
			this.getClientList()
			this.ShipmentRuleDetails = []
			this.ShowShipmentRuleList = false
		},
		selectedRouteMode(shipmentRouteModeRuleObjData) {
			this.shipmentRouteModeRuleObjData = shipmentRouteModeRuleObjData
			this.ShipmentRouteModeRule = this.shipmentRouteModeRuleObjData.value;
		},
		showRouteModeRuleDetails(data) {
			this.RuleID = data
			this.getShipmentRouteDetailsList()
		},
		getRuleList() {
			console.log('getRuleList')
			this.input = ({})
			axios({
					method: 'GET',
					'url': apiUrl.api_url_hubops + 'fetchShipmentRules?scope=withConfiguredDetails',
					'data': this.input,
					headers: {
						'authorization': 'authkey xB84JJ89Hd25'
					}
				})
				.then(result => {
					this.RuleDetails = result.data.ResponseData
					let j=0, rulelist=[], alllist=[];
					for (var i = 0; i < this.RuleDetails.length; i++) {
						if(j<3){
							rulelist.push({
								value:this.RuleDetails[i].ruleid,
								text:this.RuleDetails[i].rulename
							});
						}else{
							alllist.push(rulelist);
							rulelist=[]
							rulelist.push({
								value:this.RuleDetails[i].ruleid,
								text:this.RuleDetails[i].rulename
							});
							j=0;
						}
						j++;
					}
					alllist.push(rulelist);
					this.shipmentRouteModeRuleArray = alllist;
				}, error => {
					console.error(error)
				})
		},
		getShipmentRouteDetailsList() {
			if (this.RuleID == '') {
				return false
			}
			this.isLoading = true;
			this.input = ({});
			axios({
					method: 'GET',
					url: apiUrl.api_url_hubops + 'getShipmentRouteModeRuleDetails?ruleId=' + this.RuleID,
					data: this.input,
					headers: {
						'authorization': 'authkey xB84JJ89Hd25'
					}
				})
				.then(result => {
					this.isLoading = false;
					if (result.data.ResultCode == 100) {
						this.ShipmentRuleDetails = result.data.ResponseData;
						// for (var i = 0; i < this.ShipmentRuleDetails.length; i++) {
						// 	this.ShipmentRuleDetails[i].cod = ''
						// 	this.ShipmentRuleDetails[i].prepaid = ''
						// }
						this.len = this.ShipmentRuleDetails.length
						this.ShowShipmentRuleList = true
					} else {
						this.ShowShipmentRuleList = false
					}
				}, error => {
					console.error(error)
				})
		},
		closeRuleStatusModal() {
			this.RuleModalShow = false
		},
		//for active/inactive modal
		changeRuleStatus() {
			var newactStatus = this.modaldata.isactive ? false : true
			this.input = {
				"shipmentRuleDetailsId": this.modaldata.shipmentruledetailsid,
				"createdBy": this.createdBy,
				"isActive": newactStatus
			}
			axios({
					method: 'PUT',
					'url': apiUrl.api_url_hubops + 'inActiveShipmentRouteModeRule',
					'data': this.input,
					headers: {
						'authorization': 'authkey xB84JJ89Hd25'
					}
				})
				.then((response) => {
					if (response.data.ResultCode == 100) {
						//this.$alertify.success(response.data.ReturnMessage)
						this.$alert(response.data.ReturnMessage, "", "success");
						this.getShipmentRouteDetailsList()
						user_tracker.checkUserIP(this.userData[0], "allocateShipmentRuleToClient", this.$route.path , this.input);
					} else {
						//this.$alertify.error(response.data.ReturnMessage)
						this.$alert(response.data.ReturnMessage, "", "error");
					}
				})
				.catch((httpException) => {
					console.error('exception is:::::::::', httpException)
				})
		},
		getClientList() {
			if (this.clientObjData.accountid == undefined) {
				return false;
			} else {
				this.isLoading = true
				this.ClientDetails = [];
				var tempMemberarray = [];
				var tempfinalArray = [];
				this.listEventDetails = [];
				this.ShipmentRouteModeRule ='';
				this.input = ({})
				axios({
						method: 'GET',
						'url': apiUrl.api_url_hubops + 'fetchClientShipmentRuleByClientId?clientBusinessAccountId=' + this.clientObjData.accountid,
						'data': this.input,
						headers: {
							'authorization': 'authkey xB84JJ89Hd25'
						}
					})
					.then(result => {
						if (result.data.ResultCode == 100) {
							this.ClientDetails = result.data.ResponseData
							this.ShipmentRouteModeRule  = this.ClientDetails[0].ruleid;
							this.isLoading = false
						}
						if (result.data.ResultCode == 101) {
							//this.$alertify.error(result.data.ReturnMessage)
							this.$alert(result.data.ReturnMessage, "", "error");
							this.isLoading = false
						}
					}, error => {
						this.isLoading = false
						console.error(error)
					})
			}
		},
		allocateShipmentRuleToClient() {
			this.ShipmentRuleDetails = [];
			this.ShowShipmentRuleList = false
			if (this.Client == "" || this.ShipmentRouteModeRule == "" || this.Client == undefined || this.ShipmentRouteModeRule == undefined) {
				return false;
			} else {
				this.input = {
					"clientId": this.clientObjData.id,
					"ruleId": this.ShipmentRouteModeRule,
					"clientName": this.clientObjData.text,
					"createdBy": this.createdBy,
					"clientBusinessDetailId": Number(this.clientObjData.detailiD),
					"clientBusinessAccountId": Number(this.clientObjData.accountid)
				}
				axios({
						method: 'POST',
						'url': apiUrl.api_url_hubops + 'allocateRuleToClient',
						'data': this.input,
						headers: {
							'authorization': 'authkey xB84JJ89Hd25'
						}
					})
					.then((response) => {
						if (response.data.ResultCode == 100) {
							this.isDisabled = true;
							this.$validator.reset()
							//this.$alertify.success(response.data.ReturnMessage)
							this.$alert(response.data.ReturnMessage, "", "success");
							this.getClientList();
							user_tracker.checkUserIP(this.userData[0], "allocateShipmentRuleToClient", this.$route.path , this.input);
							// this.clientObjData = {
							// 	id: '',
							// 	text: '',
							// 	accountid:'',
							// 	detailiD:''
							// }
							this.shipmentRouteModeRuleObjData = {
								id: '',
								text: ''
							}
							this.ShipmentRouteModeRule = ''
							this.$validator.reset()
						} else {
							this.isDisabled = false;
							//this.$alertify.error(response.data.ReturnMessage)
							this.$alert(response.data.ReturnMessage, "", "error");
						}
					})
					.catch((httpException) => {
						console.error('exception is:::::::::', httpException)
					})
			}
		},
		resetForm() {
			this.clientObjData = {
				id: '',
				text: '',
				accountid: '',
				detailiD: ''
			}
			this.shipmentRouteModeRuleObjData = {
				id: '',
				text: ''
			}
			this.Client = ''
			this.ShipmentRouteModeRule = ''
			this.ClientDetails = []
			this.ShipmentRuleDetails = []
			this.ShowShipmentRuleList = false
			this.isDisabled = false;
			this.$validator.reset()
		},
		handleSubmit: function(event) {
			this.$validator.validateAll().then((result) => {
				if (!result) {
					return false;
				}
			}).catch(() => {
				console.log('errors exist', this.errors)
			});
		},
		openStatusModal(data) {
			this.modaldata = data
			this.modalShow = true
		},
		closeStatusModal() {
			this.modalShow = false
		},
		activeInactiveStatus() {
			var olddata = this.modaldata
			var newactStatus = this.modaldata.isactive ? false : true
			var url = 'deAllocateRuleToClient'
			this.input = {
				"clientBusinessAccountId": this.modaldata.clientbusinessaccountid,
				"createdBy": this.createdBy,
				"isActive": newactStatus
			}
			axios({
					method: 'PUT',
					'url': apiUrl.api_url_hubops + url,
					'data': this.input,
					headers: {
						'authorization': 'authkey xB84JJ89Hd25'
					}
				})
				.then((response) => {
					if (response.data.ResultCode == 100) {
						//this.$alertify.success(response.data.ReturnMessage)
						this.$alert(response.data.ReturnMessage, "", "success");
						this.getClientList()
						user_tracker.checkUserIP(this.userData[0], "allocateShipmentRuleToClient", this.$route.path , this.input);
					} else {
						//this.$alertify.error(response.data.ReturnMessage)
						this.$alert(response.data.ReturnMessage, "", "error");
					}
				})
				.catch((httpException) => {
					console.error('exception is:::::::::', httpException)
				})
		}

	}
}



// WEBPACK FOOTER //
// ./src/views/components/AllocateShipmentRuleToClient/AllocateShipmentRuleToClient.component.js